<!--
 * @Author: your name
 * @Date: 2021-07-09 14:26:19
 * @LastEditTime: 2022-04-22 16:52:20
 * @LastEditors: Please set LastEditors
 * @Description: 头部
 * @FilePath: \smart-community\src\layout\module\LayoutHander.vue
-->
<template>
  <div class="layoutHander">
    <div class="layoutHanderTop" :style="{ background: 'url(' + topImg + ')' }">
      <div class="time">{{ nowDate.time }}</div>
      <div class="title">
        <!-- <img src="@/assets/images/header/title.png" /> -->

        {{ title }}
      </div>
      <div class="weather">
        <div>
          {{ nowDate.week }}
          <br />
          {{ nowDate.date }}
        </div>
        <!-- <div></div> -->
      </div>
    </div>
    <div class="layoutHanderBottom">
      <main-menu
        @themeeyehelp="themeeyehelp"
        v-if="data.length !== 0"
        :data="data"
      ></main-menu>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeMount,
} from "vue";
import moment from "moment";
import MainMenu from "./menu/MainMenu.vue";
import { useRouter } from "vue-router";
import { initStyle } from "@/hooks/useStyle";
import { logout } from "@/api/login";
import util from "@util/js";
const weeks = {
  0: "星期日",
  1: "星期一",
  2: "星期二",
  3: "星期三",
  4: "星期四",
  5: "星期五",
  6: "星期六",
};
export default defineComponent({
  name: "LayoutHander",
  components: { MainMenu },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const data = reactive({
      topImg: require("@/assets/images/header/top.png"),
      nowDate: {
        date: "",
        time: "",
        week: "",
      },
      title: window.lgoinList
        ? window.localStorage.getItem("active") || "开州区智慧社区治安防控平台"
        : "开州区智慧社区联网服务平台",
      times: "",
      themeMenu: [
        { name: "明亮", key: "simple" },
        { name: "复古", key: "retro" },
        { name: "护眼", key: "eyehelp" },
        { name: "海天", key: "haitian" },
        { name: "深邃", key: "deep" },
        { name: "暗黑", key: "dark" },
        { name: "新年", key: "newYear" },
        { name: "退出登录", key: "logout" },
      ],
      name: "",
      currentTheme: localStorage.getItem("themeId"),
    });
    const refData = toRefs(data);
    const router = useRouter();
    data.name = util.getStorage("name");
    // 设置时间
    const initDate = () => {
      data.times = setInterval((_) => {
        const dateArr = moment().format("YYYY-MM-DD,HH:mm:ss,d").split(",");
        data.nowDate.date = dateArr[0];
        data.nowDate.time = dateArr[1];
        data.nowDate.week = weeks[dateArr[2]];
      }, 1000);
    };
    onBeforeMount(() => {
      if (data.times) {
        clearInterval(data.times);
      }
    });
    onMounted(() => {
      initDate();
    });
    const themeeyehelp = () => {
      data.topImg = require("@/assets/images/header/top2.png");
    };
    const switchTheme = (theme) => {
      if (theme === "logout") {
        logout();
        router.push("login");
      } else {
        initStyle(theme);
      }
    };
    return { ...refData, switchTheme, themeeyehelp };
  },
});
</script>
<style lang="scss" scoped>
.layoutHander {
  // height: 6.7vh;
  height: 10vh;
  width: 100%;
  background-color: var(--el-color-primary);
  color: #fff;
  // padding: 0 10px;
  // display: flex;
  // @include flex-row-sb-c;
  .layoutHanderTop {
    background-size: 100% 100%;
    height: 60%;
    display: flex;
    justify-content: space-between;
    div {
      width: 33%;
    }
    .weather {
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      div:nth-child(2) {
        width: 50px;
        // background: url("~@/assets/images/header/weather.png") no-repeat;
        // background-size: 100% 100%;
        margin-left: 20px;
        height: 70%;
      }
      padding-right: 30px;
    }
    .time {
      font-size: 25px;
      display: flex;
      align-items: center;
      padding-left: 30px;
    }
    .title {
      font-size: 30px;
      text-align: center;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-top: 5px;
        width: 60%;
      }
    }
  }
  .layoutHanderBottom {
    height: 40%;
    .headerLeft {
      width: 150px;
    }
    .headerLeft {
      font-size: 26px;
      font-weight: 300;
      margin-top: 10px;
    }
  }
}
</style>
